<template>
  <path fill-rule="evenodd" d="M 0.146 8.354 a 0.5 0.5 0 0 1 0 -0.708 l 2 -2 a 0.5 0.5 0 1 1 0.708 0.708 L 1.707 7.5 H 14.293 l -1.147 -1.146 a 0.5 0.5 0 0 1 0.708 -0.708 l 2 2 a 0.5 0.5 0 0 1 0 0.708 l -2 2 a 0.5 0.5 0 0 1 -0.708 -0.708 L 14.293 8.5 H 1.707 l 1.147 1.146 a 0.5 0.5 0 0 1 -0.708 0.708 l -2 -2 z"></path>
</template>
